import { useStore } from '@nanostores/react';
import {
  storageStatusStore,
  type StorageStatusState,
  type ExtendedChatHistoryItem as StoreExtendedChatHistoryItem,
} from '~/lib/stores/storageStatusStore';

// Re-export or alias the type for external use, ensuring consistency
export type ExtendedChatHistoryItem = StoreExtendedChatHistoryItem;

export function useStorageStatus(): StorageStatusState {
  const storeState = useStore(storageStatusStore);

  return {
    ...storeState,
  };
}
